/**
 * Client-side URL validation for article submission.
 * Mirrors the server-side validatePublicUrl logic (supabase/functions/_shared/validateUrl.ts)
 * but runs in the browser before inserting into the DB — gives instant feedback
 * and prevents articles from getting stuck in 'pending' due to invalid input.
 *
 * Returns null if valid, or an error string if invalid.
 */
export function validateArticleUrl(raw) {
  if (!raw || !raw.trim()) return 'Please enter a URL.';

  let parsed;
  try {
    parsed = new URL(raw.trim());
  } catch {
    // Help users who forget the scheme
    const withScheme = `https://${raw.trim()}`;
    try {
      parsed = new URL(withScheme);
      // If it parsed with https:// prepended, tell the user to add the scheme
      return `Invalid URL. Did you mean https://${raw.trim()}?`;
    } catch {
      return 'Invalid URL. Please enter a full URL starting with https://.';
    }
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return `Unsupported URL type (${parsed.protocol.replace(':', '')}). Only http and https URLs are supported.`;
  }

  return null; // valid
}
